import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { PostTradeService } from '../post-trade.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ptUtilityApps } from '../../lib/utility-apps';
import { UtilityAppsService } from '../../shared-components/utility-apps/utility-apps.service';
import { TradeSourceData } from '../../models/post-trade-models';

import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { NgxLoadingModule } from 'ngx-loading';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-trade-source-data',
  templateUrl: './trade-source-data.component.html',
  styleUrls: ['./trade-source-data.component.scss'],
  imports: [BreadcrumbComponent, NgxLoadingModule, CommonModule],
})
export class TradeSourceDataComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);
  ptSvc = inject(PostTradeService);
  ss = inject(SessionStorageService);
  uas = inject(UtilityAppsService);

  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade/TR',
    },
    {
      label: 'Trade Source Data',
      link: 'trade-source-data',
    },
  ];
  tradeId = '';
  unsubscribe: Subject<any> = new Subject();
  rights = [];
  loading = false;
  dataTables = [];
  sourceData;

  ngOnInit(): void {
    this.uas.appsList.set(ptUtilityApps);
    this.loading = true;
    this.rights = this.ss.get('rights');

    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: params => {
        if (params.id) {
          this.tradeId = params.id;
          this.ptSvc
            .viewSourceData(this.tradeId)
            .subscribe((resp: TradeSourceData) => {
              if (resp?.TradeDataRaw) {
                this.sourceData = resp.TradeDataRaw;
                this.dataTables = Object.keys(resp.TradeDataRaw);
              }
              this.loading = false;
            });
        } else {
          this.loading = false;
          this.tradeId = '';
        }
      },
      error: error => {
        this.loading = false;
        console.error('Error: ', error);
      },
    });
  }

  ngOnDestroy(): void {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  keys(obj) {
    return Object.keys(obj);
  }
}
